import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UserDetails } from 'src/app/models/user-details.model';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { ShakeAnimationService } from 'src/app/services/shake-animation/shake-animation.service';

@Component({
  selector: 'ipm-producer-join-form',
  templateUrl: './producer-join-form.component.html',
  styleUrls: ['./producer-join-form.component.scss']
})
export class ProducerJoinFormComponent implements OnInit {

  producerForm: FormGroup;
  errorMessage: string = "";
  @ViewChild( 'sellerDetails', {static: false}) sellerDetailsTemplate : TemplateRef<any>;
  constructor(public formService:FormsService,
    private browserSessionService: BrowserStorageService,
    private authService:AuthService,
    public shakeAnimation:ShakeAnimationService,
    private commonService: CommonService,
    private router:Router) {
  }

  ngOnInit(): void {
    this.createProducerForm();
  }

  /* creating a form*/
  createProducerForm() {
    this.producerForm = new FormGroup({
      'firstName': this.formService.getFormControl('name'),
      'lastName': this.formService.getFormControl('name'),
      'email': this.formService.getFormControl('email'),
      'workLink': this.formService.getFormControl('link'),
      'socialLink': this.formService.getFormControl('link'),
      'isAcceptTermCondition': this.formService.getFormControl('')
    });
    this.setPreFieldData();
  }

 setPreFieldData() {
  const currentUSerData: any = this.browserSessionService.getSessionData();
  if(currentUSerData) {
    this.authService.currentUserDetails.subscribe( (userObj: UserDetails) => {
        if (userObj &&  Object.keys(userObj).length > 0) {
          this.producerForm.controls['email'].setValue(userObj.email);
        }
        this.producerForm.controls['email'].disable();
    });
  }
 }

  /* Register Join Function */
  registerProducer() {
    this.errorMessage = "";
    const DATA = {
      "name": this.producerForm.value.firstName+' '+ this.producerForm.value.lastName,
      "email": this.producerForm.controls['email'].value,
      "work_link": this.producerForm.value.workLink,
      "social_media_link": this.producerForm.value.socialLink,
      "personal_notes": ""
    }
    if (this.producerForm.value.isAcceptTermCondition) {
      this.authService.isAcceptTermConditionSeller().subscribe( res => {
        this.authService.addInfoProducer(DATA).subscribe( res => {
          this.closeByDeviceType('reload');
        }, (error) => {
          this.errorMessage =  error.error.message;
          let className = this.commonService.getClassName('ipm-producer-form-model');
          this.shakeAnimation.addShakeAnimation(className);
        });
      }, (error) => {
          this.errorMessage =  error.error.message;
          let className = this.commonService.getClassName('ipm-producer-form-model');
          this.shakeAnimation.addShakeAnimation(className);
      });
    }

  }

  closeByDeviceType(callingFrom: string = "dashboard") {
    if (event) {
      this.commonService.closingPopupWithSendData(callingFrom)
    }
  }

  openSellerPop() {
    // this.commonService.openCommonSellerPop(this.sellerDetailsTemplate, false, true);
    this.router.navigate([]).then(result => { window.open('/seller-agreement', '_blank'); });
  }
}
